exports = module.exports = require("../../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3ST1r{position:absolute;top:0;right:0;bottom:0;left:0;display:-webkit-box;display:-ms-flexbox;display:flex;margin:10px 10px 6px}", ""]);

// exports
exports.locals = {
	"tooltipContainer": "_3ST1r"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--10-1!../node_modules/postcss-loader/lib??ref--10-2!../node_modules/sass-loader/lib/loader.js??ref--10-3!../node_modules/playable/dist/src/modules/ui/core/tooltip/tooltip-container.scss
// module id = 169
// module chunks = 0